import { render } from "./LandingSlider.vue?vue&type=template&id=cab51656&ts=true"
import script from "./LandingSlider.vue?vue&type=script&lang=ts"
export * from "./LandingSlider.vue?vue&type=script&lang=ts"

import "./LandingSlider.vue?vue&type=style&index=0&id=cab51656&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__